// Shared expansion contracts for recursive `@fun` statement processing.
// Example: one expansion pass carries warning state and known function definitions.
import type { LuisCompileWarning } from '../../types'
import type { LuisFunctionMap } from '../types'

export const MAX_FUNCTION_EXPANSION_DEPTH = 32

/** @internal Internal expansion-pass context shared across helper modules. */
export type ExpansionContext = {
  _functions: LuisFunctionMap
  _warnings: LuisCompileWarning[]
  _collectWarnings: boolean
}

/** @internal Internal nested-call expansion callback shared across helper modules. */
export type ExpandNestedCalls = (
  source: string,
  context: ExpansionContext,
  stack: string[],
  depth: number,
  baseLine: number,
) => string
